module.exports = "<p>\n  lead-property works!\n</p>\n"